import { useEffect, useRef } from "react";

export default function useEventListener(
  eventName: string,
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  handler: Function,
  element: Window | Document | Element | undefined = typeof window !==
  "undefined"
    ? window
    : undefined,
) {
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  const savedHandler = useRef<Function | undefined>(undefined);

  // Update ref.current value if handler changes.
  // This allows our effect below to always get latest handler ...
  // ... without us needing to pass it in effect deps array ...
  // ... and potentially cause effect to re-run every render.
  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(
    () => {
      const isSupported = element?.addEventListener;
      if (!isSupported) return;

      const eventListener = (event: Event) => savedHandler?.current?.(event);

      element.addEventListener(eventName, eventListener);
      //console.debug("useEventListener", { element, eventName });

      return () => {
        element.removeEventListener(eventName, eventListener);
      };
    },
    [eventName, element], // Re-run if eventName or element changes
  );
}
